@import '~style-sheet-helpers/core.less';
@import '../../../../../../app-brand/entities/entity-layer.module.less';
@import (reference) '../../../../../../constants/spacing.module.less';

.manage-add-ons-body {
  padding-left: @space-24;
}

.manage-add-ons-description {
  max-width: 525px;
}

.manage-add-ons-grid {
  border-radius: 4px;
  border: 1px solid var(--grey-300);
  margin-top: @space-24;

  .add-on-name {
    color: var(--grey-800);
    margin-right: @space-16;
  }

  .add-on-description {
    color: var(--grey-900);
  }

  .add-on-price {
    color: var(--grey-600);
  }
}

.add-on-name-cell {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.deactivation-pill {
  display: flex;
}

.empty-box-wrapper {
  align-items: center;
  color: var(--grey-800);
}

.empty-box {
  height: 64px;
}

.empty-note {
  text-align: center;
  max-width: 470px;
}
